import React from "react";

export const SectionLabel = ({ children, color = "blue" }) => {
  const palette =
    color === "amber"
      ? "text-amber-700 bg-amber-50 border-amber-100"
      : "text-blue-800 bg-blue-50 border-blue-100";
  return (
    <span
      className={`inline-flex items-center gap-2 rounded-full border ${palette} px-3 py-1 text-[11px] uppercase tracking-[0.2em] font-bold`}
    >
      <span className="h-1.5 w-1.5 rounded-full bg-current opacity-70" />
      {children}
    </span>
  );
};

export default SectionLabel;
